module.exports = __webpack_public_path__ + "img/independence-day.918b0a5e.webp";